import React, { useState } from 'react'

let MessagesWidget

// Lazy-loads the inbox popover widget on first interaction and builds the popover
// node. Mirrors useCartWidget without the cart-only progress / GA4 tracking.
function useMessagesWidget({ messages }) {
  const [isWidgetLoaded, setIsWidgetLoaded] = useState(false)

  function loadWidget(callback) {
    if (MessagesWidget) {
      callback?.()
      return
    }

    import('Pods/LazyLoaded/MessagesWidget/MessagesWidget')
      .then((module) => {
        MessagesWidget = module.default
        setIsWidgetLoaded(true)
        callback?.()
      })
      .catch((error) => {
        console.error('Failed to load MessagesWidget:', error)
      })
  }

  const isLoaded = isWidgetLoaded && !!MessagesWidget

  const popoverComponent = isLoaded ? (
    <MessagesWidget
      messages={messages.data}
      included={messages.included}
      unreadCount={messages.totalUnreadMessages}
    />
  ) : null

  return {
    isLoaded,
    loadWidget,
    popoverComponent,
  }
}

export { useMessagesWidget }
